module.exports = __webpack_public_path__ + "assets/images/premium-features/clopening-a591d8.png";